import React, { Dispatch, SetStateAction, useEffect, useRef } from 'react';
import { FormattedMessage, injectIntl, IntlShape } from 'react-intl';
import { Select } from 'antd';
import { RefSelectProps } from 'antd/lib/select';

import MultiSelect from 'src/components/general-ui/MultiSelect';
import {
  SubtenantItem,
  TenantSubscriptionDetails,
} from 'src/routes/GMDashboard/modules/types';
import { ErrorState, MTMAlertSettingsOnSaveHandlers } from '../types';
import {
  SettingsInfo,
  StyledOptionLabel,
  StyledOptionLabelTag,
  StyledWrapper,
} from './styled';
import { messages, typeToColor, typeToMessage } from './constants';
import MTMTechnicalAlerts from 'src/routes/GMDashboard/components/SubtenantCards/SubtenantSettings/AlertSettings/CombinedSettings/MTMTechnicalAlerts';

const { Option } = Select;

const customOptionRender = ({ value, label, type }: SubtenantItem) => (
  <Option value={value} label={label} key={value}>
    <StyledOptionLabel>{label}</StyledOptionLabel>
    <StyledOptionLabelTag color={typeToColor[type]}>
      <FormattedMessage {...typeToMessage[type]} />
    </StyledOptionLabelTag>
  </Option>
);

type Props = {
  setOnSaveHandlers: Dispatch<SetStateAction<MTMAlertSettingsOnSaveHandlers>>;
  setErrors: Dispatch<SetStateAction<ErrorState>>;
  intl: IntlShape;
  setSelectedSubtenants: Dispatch<SetStateAction<SubtenantItem[]>>;
  selectedSubtenants: SubtenantItem[];
  subtenantOptions: SubtenantItem[];
  subscriptionDetails: TenantSubscriptionDetails;
  setSubscriptionDetails: Dispatch<SetStateAction<TenantSubscriptionDetails>>;
  isFormEnabled?: boolean;
  displayEditableSettings?: boolean;
};

const ConnectivityAlertsSettings = ({
  selectedSubtenants,
  setSelectedSubtenants,
  subtenantOptions,
  setErrors,
  subscriptionDetails,
  setSubscriptionDetails,
  intl,
  isFormEnabled = true,
  displayEditableSettings = true,
}: Props): JSX.Element => {
  const ref = useRef<RefSelectProps>(null);
  useEffect(() => {
    if (!displayEditableSettings) {
      ref.current?.blur();
    }
  }, [displayEditableSettings]);

  return (
    <StyledWrapper>
      <MultiSelect
        selectRef={ref}
        selectedItems={selectedSubtenants.map(s => s.value)}
        options={subtenantOptions}
        handleChange={ids =>
          setSelectedSubtenants(
            subtenantOptions.filter(s => ids.includes(s.value)),
          )
        }
        placeholder={intl.formatMessage(messages.multiselectPlaceholder)}
        customOptionRender={customOptionRender}
      />
      {displayEditableSettings ? (
        <MTMTechnicalAlerts
          subscriptionDetails={subscriptionDetails}
          setSubscriptionDetails={setSubscriptionDetails}
          isFormEnabled={isFormEnabled}
          setErrors={setErrors}
        />
      ) : (
        <SettingsInfo>
          <FormattedMessage {...messages.settingsDoNoMatch} />
        </SettingsInfo>
      )}
    </StyledWrapper>
  );
};

export default injectIntl(ConnectivityAlertsSettings);
